import type { CatalogRepository } from '#/domain/catalog/CatalogRepository'

export interface UnassignLayerBatchResult {
  succeeded: string[]
  failed: string[]
}

export class UnassignLayerUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(organizationId: string, layerId: string, layerCategoryId?: string): Promise<void> {
    return this.repository.unassignLayerFromOrganization(organizationId, layerId, layerCategoryId)
  }

  // Fans out one DELETE per category client-side rather than adding a batch endpoint: cardinality
  // here is a handful of categories, each unassign is already its own transaction server-side, and
  // Promise.allSettled lets a partial failure still remove the categories that did succeed.
  async executeMany(
    organizationId: string,
    layerId: string,
    layerCategoryIds: string[],
  ): Promise<UnassignLayerBatchResult> {
    const results = await Promise.allSettled(
      layerCategoryIds.map((categoryId) => this.execute(organizationId, layerId, categoryId)),
    )

    const succeeded: string[] = []
    const failed: string[] = []
    results.forEach((result, index) => {
      const categoryId = layerCategoryIds[index]
      if (result.status === 'fulfilled') {
        succeeded.push(categoryId)
      } else {
        failed.push(categoryId)
      }
    })

    return { succeeded, failed }
  }
}
